import { get } from '../services/common/common.service';
import { entitlementsShippingInfoEndPoints } from '../constants/endpoint';

//Entitlement Search By ID - GET API to fetch the data
export const fetchEntitlementsShippingInfoById = (payload) => {
  return get(
    `${entitlementsShippingInfoEndPoints.getEntitlementsShippingInfo}?entitlementId=${payload}`,
    payload
  );
};
